import store from "@/state/store";

export default [
    {
        path: "/",
        name: "login",
        component: () => import("@/views/account/login.vue"),
        meta: {
            title: "Login",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "dashboard" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/resetpassword",
        name: "resetpassword",
        component: () => import("@/views/account/resetpassword.vue"),
        props: (route) => ({
            myQueryParam: encodeURIComponent(route.query.token),
        }),
        meta: {
            title: "resetpassword",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "resetpassword" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    // {
    //   path: "/changepassword",
    //   name: "changepassword",
    //   component: () => import("@/views/account/changepassword.vue"),
    //   meta: {
    //     title: "changepassword",
    //     beforeResolve(routeTo, routeFrom, next) {
    //       // If the user is already logged in
    //       if (store.getters["auth/loggedIn"]) {
    //         // Redirect to the home page instead
    //         next({ name: "changepassword" });
    //       } else {
    //         // Continue to the login page
    //         next();
    //       }
    //     },
    //   },
    // },
    {
        path: "/change-password",
        name: "Change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Change-password",
        },
    },
    {
        path: "/listotp",
        name: "ListOTP",
        component: () => import("@/views/listotp/index.vue"),
        meta: {
            title: "List Otp",
        },
    },
    // {
    //     path: "/force-resetpassword",
    //     name: "Force-Reset-password",
    //     component: () => import("@/views/account/force-resetpassword.vue"),
    //     meta: {
    //         title: "Force-Reset-Password",
    //     },
    // },

    // {
    //   path: "/changepassword",
    //   name: "changepassword",
    //   component: () => import("@/views/account/change-password.vue"),
    //   meta: {
    //     title: "changepassword",
    //     beforeResolve(routeTo, routeFrom, next) {
    //       // If the user is already logged in
    //       if (store.getters["auth/loggedIn"]) {
    //         // Redirect to the home page instead
    //         next({ name: "changepassword" });
    //       } else {
    //         // Continue to the login page
    //         next();
    //       }
    //     },
    //   },
    // },
    {
        path: "/register",
        name: "Register",
        component: () => import("@/views/account/register.vue"),
        meta: {
            title: "Register",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "dashboard" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Forgot Password",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "dashboard" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    //dashboard
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("@/views/dashboard/index.vue"),
    },
    
    //outlook demo
    {
        path: "/outlook-demo",
        name: "outlookDemo",
        meta: {
            title: "Outlook Theme Demo",
            authRequired: true,
        },
        component: () => import("@/views/OutlookDemo.vue"),
    },
    
    //header test
    {
        path: "/header-test",
        name: "headerTest",
        meta: {
            title: "Header Background Test",
            authRequired: true,
        },
        component: () => import("@/views/HeaderTest.vue"),
    },

    //usermanagement
    {
        path: "/usermanagement/user",
        name: "manageUser",
        meta: {
            title: "manageUser",
            authRequired: true,
        },
        component: () => import("@/views/usermanagement/manageUser/user.vue"),
    },
    {
        path: "/usermanagement/role",
        name: "manageAccess",
        meta: {
            title: "manageAccess",
            authRequired: true,
        },
        component: () => import("@/views/usermanagement/manageAcess/index.vue"),
    },

    {
        path: "/usermanagement/managerole",
        name: "managerole",
        meta: {
            title: "managerole",
            authRequired: true,
        },
        component: () => import("@/views/usermanagement/managerole/index.vue"),
    },


    //hashsettings
    {
        path: "/customer-management/customer",
        name: "Customer Management",
        meta: {
            title: "Customer",
            authRequired: true,
        },
        component: () => import("@/views/CustomerManagement/index.vue"),
    },

    //ReceiverManagement
    {
        path: "/receiver/management",
        name: "ReceiverManagement",
        meta: {
            title: "ReceiverManagement",
            authRequired: true,
        },
        component: () => import("@/views/ReceiverManagement/index.vue"),
    },
    //System Management
    {
        path: "/system/management/currency",
        name: "System Management Currency",
        meta: {
            title: "System Management",
            authRequired: true,
        },
        component: () => import("@/views/SystemManagement/currency/index.vue"),
    },
    {
        path: "/system/management/servicefee",
        name: "Service Fee",
        meta: {
            title: "System Management",
            authRequired: true,
        },
        component: () =>
            import("@/views/SystemManagement/servicefee/index.vue"),
    },

    {
        path: "/system/management/rate",
        name: "System Management Rate",
        meta: {
            title: "System Management Rate",
            authRequired: true,
        },
        component: () => import("@/views/SystemManagement/rate/tabpage.vue"),
    },
    {
        path: "/system/management/country",
        name: "System Management Country",
        meta: {
            title: "System Management Country",
            authRequired: true,
        },
        component: () => import("@/views/SystemManagement/country/index.vue"),
    },
    {
        path: "/system/management/prefund",
        name: "Prefund",
        meta: {
            title: "Prefund",
            authRequired: true,
        },
        component: () => import("@/views/SystemManagement/prefund/index.vue"),
    },
    //Banner
    {
        path: "/content/management/banner",
        name: "Banner",
        meta: {
            title: "Banner",
            authRequired: true,
        },
        component: () => import("@/views/Banner/index.vue"),
    },

    //CustomerManagement
    {
        path: "/customer/management",
        name: "Customer Management",
        meta: {
            title: "Customer Management",
            authRequired: true,
        },
        component: () => import("@/views/CustomerManagement/index.vue"),
    },

    //FAQ
    {
        path: "/content/management/faq",
        name: "Faq",
        meta: {
            title: "Faq",
            authRequired: true,
        },
        component: () => import("@/views/Faq/index.vue"),
    },

    //Testimonial

    {
        path: "/content/management/testimonial",
        name: "Testimonial",
        meta: {
            title: "Testimonial",
            authRequired: true,
        },
        component: () => import("@/views/Testimonial/index.vue"),
    },
    //Advertisement

    {
        path: "/content/management/Advertisement",
        name: "Advertisement",
        meta: {
            title: "Advertisement",
            authRequired: true,
        },
        component: () => import("@/views/Advertisement/index.vue"),
    },
    //processContent
    {
        path: "/content/management/processcontent",
        name: "Process Content",
        meta: {
            title: "Process Content",
            authRequired: true,
        },
        component: () => import("@/views/ProcessContent/index.vue"),
    },

    //testimonial
    {
        path: "/content/management/testimonial",
        name: "Testimonial",
        meta: {
            title: "Testimonial",
            authRequired: true,
        },
        component: () => import("@/views/Testimonial/index.vue"),
    },

    //content
    {
        path: "/content/management/content",
        name: "Content",
        meta: {
            title: "Content",
            authRequired: true,
        },
        component: () => import("@/views/Content/index.vue"),
    },
    //Service
    {
        path: "/content/management/service",
        name: "Service",
        meta: {
            title: "Service",
            authRequired: true,
        },
        component: () => import("@/views/Service/index.vue"),
    },
    //TransactionModule
    {
        path: "/transaction/module",
        name: "Transaction Module",
        meta: {
            title: "TransactionModule",
            authRequired: true,
        },
        component: () => import("@/views/transactionmodule/index.vue"),
    },
    //report
    //1.customerregistration
    {
        path: "/report/customer/registration",
        name: "Registration Report",
        meta: {
            title: "Registration Report",
            authRequired: true,
        },
        component: () => import("@/views/report/customerRegistrationReport.vue"),
    },
    //2.transactiondetail
    {
        path: "/report/transaction/detail",
        name: "Transaction Detail Report",
        meta: {
            title: "Transaction Detail Report",
            authRequired: true,
        },
        component: () => import("@/views/report/transactionDetail.vue"),
    },
    //3.Transactionsummary
    {
        path: "/report/transaction/summary",
        name: "Transaction Summary Report",
        meta: {
            title: "Transaction Summary Report",
            authRequired: true,
        },
        component: () => import("@/views/report/transactionSummary.vue"),
    },
    //4.eod
    {
        path: "/report/eod",
        name: "EOD Report",
        meta: {
            title: "EOD Report",
            authRequired: true,
        },
        component: () => import("@/views/report/eod.vue"),
    },
    //5.Monthly Transaction
    {
        path: "/report/monthly/transaction",
        name: "Monthly Transaction",
        meta: {
            title: "Monthly Transaction",
            authRequired: true,
        },
        component: () => import("@/views/report/monthlyTransaction.vue"),
    },
    //6.Refund
    {
        path: "/report/refund",
        name: "Refund Report",
        meta: {
            title: "Refund",
            authRequired: true,
        },
        component: () => import("@/views/report/refundReport.vue"),
    },
    //7.TransactionRateHistory
    {
        path: "/report/transaction/rate/history",
        name: "Transaction Rate History",
        meta: {
            title: "Transaction Rate History",
            authRequired: true,
        },
        component: () => import("@/views/report/transactionRateHistory.vue"),
    },
    //8.fundconversionReport
    {
        path: "/report/fund/conversion",
        name: "Fund Conversion",
        meta: {
            title: "Fund Conversion",
            authRequired: true,
        },
        component: () => import("@/views/report/fundConversion.vue"),
    }
];
